import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import numeral from "numeral";

const styles = StyleSheet.create({
  body: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 20
  },
  title: {
    marginBottom: 3,
    fontSize: 18,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  subtitle: {
    marginBottom: 2,
    fontSize: 13,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  text: {
    margin: 1,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  //TABLE-----------------------
   table: {
    width: '100%',
    top: 15,
    paddingBottom: 40
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  borderBottom: {
    borderBottom: '1 solid #0000'
  },
  bold: {
    fontWeight: 'bold',
  },
  rowText: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    fontWeight: 'bold',
  },
  alignLeft: {
    textAlign: 'left'
  },
  alignCenter: {
    textAlaign: 'center'
  },
  alignRight: {
    textAlign: 'right'
  },
  paddingNotes: {
    paddingBottom: 40
  },
  // So Declarative and unDRY 👌
  row1: {
    width: '30%',
  },
  row2: {
    width: '30%',
  },
  row3: {
    width: '40%',
  }
});



const PDFCheckViewReference = ({ date, payTo, cleared, printed, allocation, balance, checkTotal, itemsCheck, itemsAllocation, notes, chkno }) => {

  return (
    <Document>
      <Page style={styles.body}>
        {/* <Text style={styles.header} fixed>qweqwe</Text> */}
        <Text style={styles.title}>
          Check Reference # {chkno}
        </Text>
        <Text style={styles.text}>
          Date : {date}
        </Text>
        <Text style={styles.text}>
          Pay To: {payTo}
        </Text>
        <Text style={styles.text}>
          Cleared: {cleared}
        </Text>
        <Text style={styles.text}>
          Printed: {printed}
        </Text>
        <Text style={styles.text}>
          Allocation: {allocation}
        </Text>
        <Text style={styles.text}>
          Balance: {balance}
        </Text>
        
        {/* TABLE ALLOCATIONS */}
        
        <View style={styles.table}>
          <Text style={styles.subtitle}>
            Allocations
          </Text>
          <View style={[styles.row, styles.rowText, styles.borderBottom]}>
            <Text style={[styles.row1, styles.rowText, styles.alignLeft]}>Date</Text>
            <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>Reference</Text>
            <Text style={[styles.row3, styles.rowText, styles.alignRight]}>Amount</Text>
          </View>
          {itemsAllocation ? itemsAllocation.map((row, i) => (
            <View key={i} style={styles.row} wrap={false}>
              <Text style={[styles.row1, styles.rowText, styles.alignLeft]}>{row.date}</Text>
              <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>{row.reference}</Text>
              <Text style={[styles.row3, styles.rowText, styles.alignRight]}>{numeral(row.amount).format('00,0.00')}</Text>
            </View>
          )) : ''}
        </View>

        {/* TABLE CHECK */}
        
        <View style={styles.table}>
          <Text style={styles.subtitle}>
            Check Details
          </Text>
          <View style={[styles.row, styles.rowText, styles.borderBottom]}>
            <Text style={[styles.row1, styles.rowText, styles.alignLeft]}>Date</Text>
            <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>Description</Text>
            <Text style={[styles.row3, styles.rowText, styles.alignRight]}>Amount</Text>
          </View>
          {itemsCheck ? itemsCheck.map((row, i) => (
            <View key={i} style={styles.row} wrap={false}>
              <Text style={[styles.row1, styles.rowText, styles.alignLeft]}>{row.date}</Text>
              <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>{row.description}</Text>
              <Text style={[styles.row3, styles.rowText, styles.alignRight]}>{numeral(row.amount).format('00,0.00')}</Text>
            </View>
          )) : ''}
        </View>

      {/* TOTALITIES */}
      <Text style={[styles.text,styles.alignRight]}>
          Total: {checkTotal}
      </Text>

      {/* NOTES */}
      <Text style={[styles.text,styles.alignLeft]}>
          **Notes**:
      </Text>
      <Text style={[styles.text,styles.alignLeft,styles.paddingNotes]}>
        {notes}
      </Text>

      {/* Encoded */}
      {/* <Text style={[styles.text,styles.alignLeft]}>
          |Encoded By: {encoder}
      </Text>
      <Text style={[styles.text,styles.alignLeft]}>
          |Approved By: {approver}
      </Text> */}


        <Text 
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  );
};

export default PDFCheckViewReference;